<template>
	<div>
    <div v-if="detail_loader" style="position:absolute; top:0; right:0; bottom:0; left:0; padding-top: 25%;background-color:rgba(255,255,255,0.31)">
          <div class="text-xs-center">
            <v-progress-circular
                :size="70"
                :width="7"
                indeterminate
                color="white"
                class="text-xs-center my-5"
                large
            ></v-progress-circular>
          </div>
      </div>  
		<v-container fluid grid-list-md class="padding_10" v-else>
		    <v-layout row wrap>
		      <v-flex xs12 sm8 md8 class="text-xs-left">
		        <!--<h2>Create Workspace</h2>-->
		      </v-flex>
		     
		    </v-layout>
            <v-layout row wrap class="table_opacity_8">
              <v-flex xs12>
                <v-card>
                 <v-card-text>
                   <v-container fluid grid-list-md style="padding: 0px 0px 0px 0px">
                    <v-layout class="index_header">
                       <v-flex xs12 md6>
                       </v-flex>
                       <v-flex xs12 md6 class="text-xs-right"> 
                         <v-btn v-if="announcement_detail.status == 'created'" slot="activator" color="#0A8290" class="white--text" @click="publish_model = true">
                           Publish
                          </v-btn> 
                          <v-btn v-else slot="activator" color="#0A8290" class="white--text" @click="publish_model = true" disabled>
                           Published
                          </v-btn>    
                       </v-flex>
                     </v-layout>
                    <v-layout row wrap>
                      <v-flex xs6 sm2>
                        <label>Announccement Type: </label>
                      </v-flex>
                      <v-flex xs6 sm3>
                        <v-autocomplete
                            :items="announcement_types"
                             name="Type"
                             v-model="announcement_detail.type"
                             return-object
                             item-text="title"
                             item-value="id"
                             selected
                             disabled
                            >
                        </v-autocomplete>
                      </v-flex>
                </v-layout>
                    <v-layout row wrap>
                  <v-flex xs6 sm2>
                    <label>Local Line: </label>
                  </v-flex>
                  <v-flex xs6 sm3>
                    <v-autocomplete
                        :items="local_lines"
                         name="Local Line"
                         v-model="announcement_detail.local_line"
                         return-object
                         item-text="code"
                         item-value="id"
                         filled
                         chips
                         multiple
                         disabled
                        >
                    </v-autocomplete>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs6 sm2>
                    <label>Title: </label>
                  </v-flex>
                  <v-flex xs6>
                      <v-text-field 
                         name="Title"
                         v-model="announcement_detail.title"
                         label="Title"
                         disabled
                      ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row wrap>
                      <v-flex xs6 sm2>
                        <label>Description: </label>
                      </v-flex>
                    <v-flex xs6>
                      <v-textarea
                        name="Description"
                        v-model="announcement_detail.description"
                        rows="2"
                        disabled
                        >
                      </v-textarea>
                    </v-flex>
               </v-layout>
                    
                <v-layout row wrap>
                      <v-flex xs6 sm2>
                        <label>Body: </label>
                      </v-flex>
                    <v-flex xs6>
                    <vue-editor 
                      name="Announcement Body"
                      v-model="announcement_detail.body"
                      disabled
                     ></vue-editor>
                  </v-flex>
                </v-layout>
              </v-container>
                </v-card-text>
            </v-card>
              </v-flex>
            </v-layout>
		   <v-dialog
          v-model="publish_model"
          scrollable 
          :overlay="false"
          max-width="500px"
          transition="dialog-transition"
          persistent
          >
        <v-card>
          <v-form>
            <v-card-text>
              <v-layout row wrap>
               <v-flex xs12 md12 lg12>
               <h3>Are you sure you want to publish this announcement?</h3>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" small  @click="publishAnnouncement()">OK</v-btn>
            <v-btn color="black" small flat type="reset" @click="publish_model = false">Cancel</v-btn>
            
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
		    <v-snackbar
          :color="snackBar.color"
          :top="snackBar.top"
          :bottom="snackBar.bottom"
          :left="snackBar.left"
          :right="snackBar.right"
          v-model="snackBar.show"
        >
        {{ snackBar.message }}
        <v-btn dark flat @click.native="snackBar.show = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
		</v-container>
	</div>
</template>
<script>
import moment from "moment";
import { VueEditor, Quill } from 'vue2-editor';

const Block = Quill.import('blots/block');
Block.tagName = 'DIV';
Quill.register(Block, true);
export default {
	created(){},
	computed:{
		// workspaceRequestCode:function(){
		// 	return this.announcement_detail.office_id.name + '/'+ this.announcement_detail.tower_id.name + '/' + this.announcement_detail.wing_id.name +'/'+this.announcement_detail.type+'/'+this.announcement_detail.number;
		// }
	},
  components: {
    VueEditor
  },
	watch:{
                 
    },
	methods:{
		validateBeforeSubmit: function(scope) {
		      this.$validator.validateAll(scope).then(result => {
		        if (result) {
		          this[scope]();
		        }
		     });
    		},

    getAnnouncementDetails: function() {
      this.detail_loader = true;
      axios
        .get(
          `${process.env.VUE_APP_API_URL}/api/v1/show-announcement/`+
            this.$route.params.id,{headers:this.$headers}
        )
        .then(response => {
          if (response.data.status == 1) {
            this.announcement_detail = response.data.announcement;
            this.announcement_detail.local_line = response.data.line_announcements;
            // console.log(this.announcement_detail.body)
            this.detail_loader = false;
          }
          
        })
        .catch(error => {
          console.log(error);
        });
    },

		    getTypeList:function()
		    {
		    axios
            .get(`${process.env.VUE_APP_API_URL}/api/v1/announcement-types`,{headers:this.$headers})
            .then(response => {
              if (response.data.status == 1)
              { 
                this.announcement_types = response.data.types;
                this.announcement_detail.type = this.announcement_types[0];
              }
             
            })
		    },
        getLocalLineList:function()
        {
        axios
            .get(`${process.env.VUE_APP_API_URL}/api/v1/local-lines`,{headers:this.$headers})
            .then(response => {
              if (response.data.status == 1)
              { 
                this.local_lines = response.data.local_lines;
              }
             
            })
        },
        publishAnnouncement:function(){
           axios.post(`${process.env.VUE_APP_API_URL}/api/v1/publish-announcement`, {announcement_id:this.$route.params.id},{headers:this.$headers}).then((response)=>{
            
            if(response.data.status == 1)
            {
              this.response_message = response.data.message;
              this.response_status =  response.data.status;
              this.publish_model = false;
              this.snackBar.message = response.data.message;
              this.snackBar.show = true;
              this.getTypeList();
              this.getLocalLineList();
              this.getAnnouncementDetails();
            }
            if(response.data.status == 2)
            {
              this.response_message = response.data.message;
              this.response_status =  response.data.status;
              this.publish_model = false;
              this.snackBar.message = response.data.message;
              this.snackBar.show = true;
            }
            
          }).catch((error)=>{
          
          }).finally(()=>{
            
          }); 
        }, 
		    
	},
	data:()=>{
		return{
      publish_model:false,
			announcement_detail:{},
			detail_loader:false,
			valid:false,
			floor_list:[],
			announcement_types:[],
      local_lines:[],
			tower_list:[],
			wing_list:[],
			auth_user:{
        roles:[{}]
      },
      workspaceRequestCode:"",
      snackBar: {
                show: false,
                color: "",
                message: "",
                top: true,
                right: true,
                bottom: false,
                left: false
          },
		
		}
	},

	mounted(){
    this.getAnnouncementDetails();
    this.getLocalLineList();
		this.getTypeList();
	},
};
</script>
